import React from 'react';
import PropTypes from 'prop-types';

export const Icons = ({ size, width, height, color = 'black', Icon, ...other }) => (
  <Icon width={width || size} height={height || size} fill={color} {...other} />
);

Icons.propTypes = {
  size: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  Icon: PropTypes.func,
};

export default Icons;
